import ru from 'apexcharts/dist/locales/ru.json'
import en from 'apexcharts/dist/locales/en.json'
import ua from 'apexcharts/dist/locales/ua.json'

export class Charts {
    static barChart(data = [], names = [], lang = 'en') {
        return {
            series: [
                {
                    name: 'Leads',
                    data
                }
            ],
            chartOptions: {
                chart: {
                    defaultLocale: lang,
                    locales: [ru, en, ua]
                },
                colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
                plotOptions: {
                    bar: {
                        barHeight: '50%',
                        distributed: true,
                        horizontal: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: names,
                    tickAmount: data.some(el => el > 4) ? 0 : 1,
                    labels: {
                        formatter(value) {
                            return value.toFixed(0)
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter(y) {
                            return y.toFixed(0)
                        }
                    }
                }
            }
        }
    }

    static pieChart(data = [], lang) {
        return {
            chartOptions: {
                chart: {
                    defaultLocale: lang,
                    locales: [ru, en, ua]
                }
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            legend: {
                show: false
            },
            series: [
                {
                    name: 'Access source',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    color: ['#FF9F43', '#28C76F', '#EA5455', '#87ceeb', '#7367F0'],
                    data,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        }
    }
}
